// Shared with the lender marketplace and the pending/accepted offer viewers.
export const isTruthyFlag = (value) =>
  value === true || value === 1 || value === "1" || value === "true";

export const shouldHideProfileContactInfo = (loan) =>
  Boolean(loan?.blanko_contact) ||
  isTruthyFlag(loan?.sl_created) ||
  isTruthyFlag(loan?.borrower?.sl_created) ||
  isTruthyFlag(loan?.borrower_summary?.sl_created) ||
  isTruthyFlag(loan?.borrower_data?.sl_created) ||
  isTruthyFlag(loan?.user?.sl_created);

export const getLoanProfileTabs = (sccbReportData) => {
  const tabs = [
    { name: "Personal Information" },
    { name: "Corporate Information" },
    { name: "NOA History" },
    { name: "Capitals" },
    { name: "Financials" },
    { name: "Shareholders" },
    { name: "Borrower Report" },
    { name: "Customer Document Analysis", isNew: true },
    { name: "MLCB Analysis", isNew: true },
  ];
  if (sccbReportData) tabs.splice(7, 0, { name: "SCCB Report", isNew: true });
  return tabs;
};

export const SCCB_EXCLUDE_COLUMNS = [
  "AMOUNT 2",
  "AMOUNT 3",
  "AMOUNT 4",
  "AMOUNT 5",
  "PLA STATUS",
  "PLA FILE REF",
  "DOC REMARKS",
  "STATUS DATE",
  "PLA STATUS DATE",
  "PLA ID",
  "DEF TYPE",
  "DEF STATUS",
  "DEF STATUS DATE",
  "DEF FILE REF",
  "DEF LAW FIRM",
  "DEF SOLICITOR",
  "DEF SOLICITOR ID",
  "PLA SOLICITOR ID",
  "CASE NO",
  "PAY LOAN ID",
];
